function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 1
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 9H7V5H5C3.9 5 3 5.9 3 7V9ZM3 14H7V10H3V14ZM8 14H12V10H8V14ZM13 14H17V10H13V14ZM8 9H12V5H8V9ZM13 5V9H17V5H13ZM18 14H22V10H18V14ZM5 19H7V15H3V17C3 18.1 3.9 19 5 19ZM8 19H12V15H8V19ZM13 19H17V15H13V19ZM18 19H20C21.1 19 22 18.1 22 17V15H18V19ZM18 5V9H22V7C22 5.9 21.1 5 20 5H18Z",
  fill: "current"
}));

function SvgViewCarousel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#263341",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCarousel);
export default __webpack_public_path__ + "static/media/view-carousel.f959cb74.svg";
export { ForwardRef as ReactComponent };